import { supabase } from "./supabase"

export async function getEmailDomainLoginRestriction(): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from("settings")
      .select("value")
      .eq("key", "restrict_email_domain_login")
      .maybeSingle()

    if (error) {
      console.error("Error fetching email domain login restriction setting:", error)
      return false
    }

    if (!data) {
      return false
    }

    return data.value === "true"
  } catch (error) {
    console.error("Error in getEmailDomainLoginRestriction:", error)
    return false
  }
}

export async function getEmailDomainRegisterRestriction(): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from("settings")
      .select("value")
      .eq("key", "restrict_email_domain_register")
      .maybeSingle()

    if (error) {
      console.error("Error fetching email domain register restriction setting:", error)
      return false
    }

    if (!data) {
      return false
    }

    return data.value === "true"
  } catch (error) {
    console.error("Error in getEmailDomainRegisterRestriction:", error)
    return false
  }
}

export async function setEmailDomainLoginRestriction(enabled: boolean): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("settings")
      .upsert({ key: "restrict_email_domain_login", value: enabled ? "true" : "false" }, { onConflict: "key" })

    if (error) {
      console.error("Error updating email domain login restriction setting:", error)
      return false
    }

    return true
  } catch (error) {
    console.error("Error in setEmailDomainLoginRestriction:", error)
    return false
  }
}

export async function setEmailDomainRegisterRestriction(enabled: boolean): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("settings")
      .upsert({ key: "restrict_email_domain_register", value: enabled ? "true" : "false" }, { onConflict: "key" })

    if (error) {
      console.error("Error updating email domain register restriction setting:", error)
      return false
    }

    return true
  } catch (error) {
    console.error("Error in setEmailDomainRegisterRestriction:", error)
    return false
  }
}

export async function getEmailDomainRestriction(): Promise<boolean> {
  return await getEmailDomainLoginRestriction()
}

export async function setEmailDomainRestriction(enabled: boolean): Promise<boolean> {
  return await setEmailDomainLoginRestriction(enabled)
}

export function validateEmailDomain(email: string): boolean {
  return email.toLowerCase().endsWith("@procap.nl")
}
